import scenarioApi from 'src/api/scenario.api'
import type { Scenario, SubScenario } from 'src/dto'

class ScenearioController {
  async fetchUserScenario() {
    const {
      data: { data },
    } = await scenarioApi.getUserScenario()

    return new Set(data)
  }

  async postScenario(id: Scenario['id'] | SubScenario['id']) {
    await scenarioApi.postScenario(id)
  }

  async fetchLastAssginedStudentId() {
    const {
      data: { data },
    } = await scenarioApi.getLatestAssignedStudent()
    return data
  }

  async fetchLastScoredStudentId() {
    const {
      data: { data },
    } = await scenarioApi.getLatestScoredStudent()
    return data
  }

  async unLikeSubScenario(id: SubScenario['id']) {
    return await scenarioApi.deleteSubScenario(id)
  }
}

export const scenarioController = new ScenearioController()
